import { useRef } from 'react';

// information for GA4 dataLayer
export const DONATION_FORM_NAME = 'donation form';

export const DONATION_FREQUENCY = {
    ONCE: 'once',
    MONTHLY: 'monthly',
};

export const CRM_DONATION_TYPE = {
    [DONATION_FREQUENCY.ONCE]: 'Single Gift',
    [DONATION_FREQUENCY.MONTHLY]: 'Monthly Gift',
};

export const CREDIT_CARD_PROVIDER = {
    AuthorizeNet: 'authorize-net',
    IPG: 'ipg',
    Bambora: 'bambora',
    payFURL: 'payfurl',
};

export const PAYMENT_TYPE = {
    CREDIT_CARD: 'Credit Card',
    DIRECT_DEBIT: 'Direct Debit',
    PAYPAL: 'Paypal',
};

export function resetFocusSectionDonation(): void {
    const section = document.querySelector('.donation-block');
    const isSectionExists = typeof section !== 'undefined' && section !== null;

    if (isSectionExists) {
        section.scrollIntoView({ behavior: 'smooth' });
    }
}

export function useFirstRender(): boolean {
    const ref = useRef(true);
    const firstRender = ref.current;
    ref.current = false;

    return firstRender;
}

